/**
 *
 * @/services/endpoints/slots.js
 *
 */

//
// IMPORTS
//

import { httpGet, httpPost } from "@/services/api/http"

//
// EXPORTS
//

// --- Get slots visibility status by group, year and month
export const apiGetSlotsVisibility = ({ groupID, year, month }) => httpGet({
  route: `api/v1/sos-portal/groups/${groupID}/slots-visibility?year=${year}&month=${month}`,
})

// --- Set slots visibility status by group, year and month
export const apiSetSlotsVisibility = ({ groupID, year, month, visible }) => httpPost({
  route: `api/v1/sos-portal/groups/${groupID}/slots-visibility`,
  fields: { year, month, visible },
})

// --- Configure (create/update in bulk) the TIPO (clinical) + OWNER (municipio/reservado) of individual duty slots
// slots: [{ duty_id, scale_id, doctor_id, slot_index, slot_start, slot_end, slot_type, owner_type, municipality_id }]
export const apiSetDutySlots = ({ groupID, slots }) => httpPost({
  route: `api/v1/sos-portal/groups/${groupID}/duty-slots`,
  fields: { slots },
})

// --- List already configured duty slots, either by duty_ids or by doctor_id + date range (Y-m-d H:i:s, UTC)
export const apiListDutySlots = ({ groupID, dutyIDs, doctorID, start, end }) => httpGet({
  route: `api/v1/sos-portal/groups/${groupID}/duty-slots${
    Array.isArray(dutyIDs) && dutyIDs.length > 0
      ? `?duty_ids=${encodeURIComponent(dutyIDs.join(','))}`
      : `?doctor_id=${encodeURIComponent(doctorID || '')}&start=${encodeURIComponent(start || '')}&end=${encodeURIComponent(end || '')}`
  }`,
})
